// import api from '../api'
import Test from '../components/blog/TestThermique'

// Vue.prototype.$api = api

new Vue({
  el: '#test-thermique',
  render: h => h(Test)
});
